export default function ChatGpt() {
  return (
    <div className="flex flex-col items-center gap-4 mt-8">
      <img className="w-[100px]" src="/chatgpt.svg" alt="ChatGPT" />
      <p className="text-4xl">Make a Phone Call, a GPT by Vibrato </p>
      <a
        href="https://chat.openai.com/g/g-BsChUhBjC-make-a-phone-call-by-vibrato"
        className="w-50 bg-[#8634DC] text-white font-bold py-2 px-4 rounded inline-block text-center"
      >
        Try it out
      </a>
      <p className="font-normal max-w-lg text-center">
        Our custom GPT enables you to define and make any type of call using ChatGPT, beyond what we have in our task
        library. Make calls directly from your session in ChatGPT.
      </p>
      <p className="italic">A ChatGPT Plus subscription is required.</p>
      <div className="flex flex-col items-center gap-2 font-normal my-4">
        <p>Use it for: </p>
        <ul className="list-disc justify-center">
          <li>Custom requests 🎺</li>
          <li>Business calls 📈</li>
          <li>Attaching receipts or documents 📑</li>
          <li>Negotiations 🏦</li>
        </ul>
      </div>
      <div className="flex flex-wrap gap-12 justify-center">
        <img className="w-[600px] rounded-lg" src="/gpt-example.png" alt="Vibrato GPT" />
      </div>
    </div>
  )
}
